module.exports = __webpack_public_path__ + "static/mainLogo-664c66c4cc476ce1075b5786ab0cda34.png";